// Using standard breakpoints for google dev tools
const sizes = {
  /* Small devices (portrait tablets and large phones, 600px and up) */
  tablet: "600px",
  /* Medium devices (landscape tablets, 768px and up) */
  tabletLandscape: "768px",
  /* Large devices (laptops/desktops, 992px and up) */
  laptop: "992px",
  laptopL: "1200px",
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  desktop: "1440px",
};

export const devices = {
  tablet: `only screen and (min-width:${sizes.tablet})`,
  tabletLandscape: `only screen and (min-width:${sizes.tabletLandscape}) and (orientation: landscape)`,
  laptop: `only screen and (min-width:${sizes.laptop})`,
  laptopL: `only screen and (min-width:${sizes.laptopL})`,
  desktop: `only screen and (min-width:${sizes.desktop})`,
};
